import { useWithholdingsTranslation } from './i18n';
import type { WithholdingDto } from './types';

export interface WithholdingTotalCellProps {
  row: WithholdingDto;
  formatAmount: (value: number) => string;
}

/**
 * Celda del valor total de una retención (FEAT-105-11.01).
 *
 * Cuando la fila es manipulada y el backend expone `originalTotalValue` (GAP-2),
 * muestra el valor original del motor en un tooltip (atributo `title` nativo).
 * Si el BE aún no expone `original_*`, degrada a la celda simple sin tooltip.
 */
export function WithholdingTotalCell({ row, formatAmount }: WithholdingTotalCellProps) {
  const { t } = useWithholdingsTranslation();

  const hasOriginal = row.isManipulated && typeof row.originalTotalValue === 'number';
  const tooltip = hasOriginal
    ? t('withholdings.origin.originalTooltip', { value: formatAmount(row.originalTotalValue as number) })
    : undefined;

  return (
    <span
      className={`tabular-nums ${hasOriginal ? 'underline decoration-dotted underline-offset-2 cursor-help' : ''}`}
      title={tooltip}
    >
      {formatAmount(row.totalValue)}
    </span>
  );
}
